import { Component, OnInit } from '@angular/core';
import * as ImagesData from '../../assets/imagesdata.json';

@Component({
  selector: 'app-fluoroscopypreview-report',
  templateUrl: './fluoroscopypreview-report.component.html',
  styleUrls: ['./fluoroscopypreview-report.component.css']
})
export class FluoroscopypreviewReportComponent implements OnInit {

  title = 'HtmltoPdfConverter';
  imageArray:[] = [];

  constructor(){
    var tt = ImagesData;
    this.imageArray = (<any>tt).default;
  }
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

  downloadPDF(){
  document.getElementById("btndum").click();

  }

}
